/* global process */

import {register} from 'register-service-worker';
import Vue from 'vue';

if (process.env.NODE_ENV === 'production' && Vue.$env.isCommunity && ['www', 'frontend-vm'].includes(Vue.$env.subDomain)) {
    register(`${process.env.BASE_URL}service-worker.js`, {
        ready() {
            console.debug('App is being served from cache by a service worker.');
        },
        registered() {
            console.debug('Service worker has been registered.');
        },
        cached() {
            console.debug('Content has been cached for offline use.');
        },
        updatefound() {
            console.debug('New content is downloading.');
        },
        updated() {
            console.debug('New content is available; please refresh.');
        },
        offline() {
            console.debug('No internet connection found. App is running in offline mode.');
        },
        error(error) {
            console.error('Error during service worker registration:', error);
        },
    });
}
